<template>
  <div>
    <Header />
    <div class="open-card-container">
        <div>
          <p class="open-card-title">
            <span>{{ $t("Step") }} 1:</span>
          </p>
          <p class="open-card-text">
            <span>
              {{$t("Scan the QR code, register and log in to your account. For your first login, you need to complete KYC verification, and only after completing KYC verification can you activate the card.")}}
            </span
            >
          </p>
          <div class="open-card-content-img">
            <img :src="currentImg1" alt="" />
          </div>
        </div>
        
        <div>
          <p class="open-card-title">
            <span>{{ $t("Step") }} 2:</span>
          </p>
          <p class="open-card-text">
            <span
              >{{ $t("Tap the 'Card' button at the bottom to enter the Card List page. On the Card List page, tap 'Apply for Card' to start the card application process.")}}</span
            >
          </p>
          <div class="open-card-content-img">
            <img :src="currentImg2" alt="" />
          </div>
        </div>
        <div>
          <p class="open-card-title">
            <span>{{ $t("Step") }} 3:</span>
          </p>
          <p class="open-card-text">
            <span
              >
              {{ $t("After entering the card activation page, select 'Get Card Now' under 'Physical Card' to start the physical card activation process.")}}</span
            >
          </p>
          <div class="open-card-content-img">
            <img :src="currentImg3" alt="" />
          </div>
        </div>
        <div>
          <p class="open-card-title">
            <span>{{ $t("Step") }} 4:</span>
          </p>
          <p class="open-card-text">
            <span
              >
              {{ $t("During the physical card issuance process, select 'Yes, I have already received the physical card', tap 'Create Card' below to enter the physical card activation page. Enter your card number to obtain the activation code— the system will send the code to your email address. Input the activation code and tap 'Activate Now' to complete the activation.")}}
              </span
            >
          </p>
          <div class="open-card-content-img">
            <img :src="currentImg4" alt="" />
          </div>
        </div>
         <div>
          <p class="open-card-title">
            <span>{{ $t("Step") }} 5:</span>
          </p>
          <p class="open-card-text">
            <span
              >
              {{ $t("After the card is successfully activated, tap Return to Card List'. You can view and manage your card in the Card List.")}}
              </span>
          </p>
          <div class="open-card-content-img">
            <img :src="currentImg5" alt="" />
          </div>
        </div>

      </div>
    <!-- <FooterSection /> -->
  </div>
</template>

<script>
import Header from "@/components/one/header.vue";
// import FooterSection from "@/components/layout/FooterSection.vue";
import ri1 from "@/assets/opencard/ri1.png";
import ri2 from "@/assets/opencard/ri2.png";
import ri3 from "@/assets/opencard/ri3.png";
import ri4 from "@/assets/opencard/ri4.png";
import ri5 from "@/assets/opencard/ri5.png";
import ying1 from "@/assets/opencard/ying1.png";
import ying2 from "@/assets/opencard/ying2.png";
import ying3 from "@/assets/opencard/ying3.png";
import ying4 from "@/assets/opencard/ying4.png";
import ying5 from "@/assets/opencard/ying5.png";
export default {
  components: {
    Header,
    // FooterSection,
  },
  data() {
    return {
      currentImg1: ying1,
      currentImg2: ying2,
      currentImg3: ying3,
      currentImg4: ying4,
      currentImg5: ying5,
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLocale: {
      handler(newLocale) {
        this.updateImages(newLocale);
      },
      immediate: true
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    updateImages(locale) {
      if (locale === 'ja') {
        // 日语显示 ri 图片
        this.currentImg1 = ri1;
        this.currentImg2 = ri2;
        this.currentImg3 = ri3;
        this.currentImg4 = ri4;
        this.currentImg5 = ri5;
      } else {
        // 默认显示英文图片
        this.currentImg1 = ying1;
        this.currentImg2 = ying2;
        this.currentImg3 = ying3;
        this.currentImg4 = ying4;
        this.currentImg5 = ying5;
      }
    }
  },
};
</script>
<!-- 媒体查询 -->
<style scoped lang="scss">
// 电脑端样式
// 电脑端样式
.open-card-container {
  width: 400px;
  margin: 0 auto;
  height: 100%;
  background-color: #f5f5f5;
  padding: 10px 30px;
}
.open-title {
  color: #000;
  font-family: MiSans;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 10px;
  text-align: center;
  position: relative;
  margin-bottom: 10px;

  .back-icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .language-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #333;
    transition: color 0.3s;

    // &:hover {
    //   color: var(--theme-primary);
    // }

    &:active {
      opacity: 0.7;
    }
  }
}
.open-card-title {
  color: #ff0000;
  font-family: MiSans;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 10px;
}
.open-card-text {
  color: #000;
  font-family: MiSans;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 10px;
}
.open-card-content-img {
  margin-bottom: 20px;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

// 移动端样式
@media (max-width: 768px) {
  .open-title {
    //文字居中
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
    margin-top: 10px;
    font-weight: 500;
  }
  .open-card-container {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    padding: 10px 10px;
  }
  .open-card-container {
    .open-card-title {
      color: red;
      font-family: MiSans;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0%;
      margin-bottom: 2px;
    }
    .open-card-text {
      color: #000;
      font-family: MiSans;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0%;
      margin-bottom: 10px;
    }
    .open-card-content-img {
      margin-bottom: 20px;
    }
  }
}

// 语言选择器样式
.language-picker {
  padding: 20px;
  background-color: #fff;

  .language-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .language-picker-title {
      font-size: 18px;
      font-weight: 600;
      color: #000;
      font-family: MiSans;
    }

    .language-picker-close {
      font-size: 24px;
      color: #999;
      cursor: pointer;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &:active {
        opacity: 0.6;
      }
    }
  }

  .language-options {
    .language-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 12px;
      border-radius: 12px;
      margin-bottom: 8px;
      cursor: pointer;
      transition: all 0.3s;
      font-family: MiSans;

      span {
        font-size: 16px;
        color: #333;
      }

      .checkmark {
        color: var(--theme-primary);
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        background-color: #f5f5f5;
      }

      &:active {
        background-color: #eee;
      }

      &.active {
        background-color: #9FE87040;
        border: 1px solid var(--theme-primary);

        span {
          color: var(--theme-primary);
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
